/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
} from "../CreateEvent/style";

import {  closeIcon,  CloseIconBranding,  PromotionalDocIcon,  RecognitionCloseIcon, UploadHDMIcon, WeekDropdownIcon} from "../../utils/icons";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import { Border } from "../Journeys/styles";
import { FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import Editor from "../CKEditor";
import { Main } from "../AdminTeamCreation/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
import { RadioButton, RadioButtonWrapper } from "../RecogntionAdmin/styles";
import { ActionButton, MoreOptionText, OptionsContainer, ToggleCircle, ToggleContainer, ToggleWrapper, WeekContainer, WeekWrapper } from "./styles";
import { InputImage, RemoveImageV2, UploadPhotoContainer } from "../common/CommonImageUploader/style";
import { AddWellnessChallenge, ConvertCsvToJson,GetChallengeLevel } from "../../redux/constants/apiConstants";
import { wellnessChallengePoints } from "../../../mockData";
import { toast } from "react-toastify";
import { fetchApi } from "../../utils/methods";
import CSVList from "../PeopleHomeV2/CSVList";
import Waiting from "../Waiting";

class CreateChallengeForm extends Component {
  constructor(props) {
    super(props);
    this.csvInputRef = React.createRef();   
    this.state = {
      title: "",
      videoTitle: "",
      videoUrl: "",
      challenge_level: null,
      pointValue:"",
      url: "",
      pillar_Id:this.props.history.location?.state?.category_Id,
      options: ["", ""], 
      activeQuestion: 0, 
      feedbackActiveQuestion: 0,
      description: "",
      imageName: "",
      challengePointValue:null,
      challengePointKey: null,
      imgSrc: "",
      classTypeKey: "",
      // WellbeingPillars:[],
      selectedValues:[],
      buttonstatus: false,
      step: 1,
      selectedChallengePoint: '',
      file: null,
      fileName: "",
      csvUpload: false,
      points:null,
      so: false,
      isVideoUrl:false,
      showBack:false,
      buttonClickScrollTop:false,
      so2: false,
      levelOpen:true,
      question:"",
      levels:null,
      getCoachData:[],
      loading:false,
      so3: false,
      iseventUrlMsg: "",
      coachName: '',
      levelNumber:null,
      printSampleBiometricCSV:false,
      charCount:0,
      selectedOption: 0,
      onSiteCategories: [],
      getThemesValue:[],
      selectedCategory: null,
      questions: [
        { text: "", options: ["", ""], allowMultiple: false },
        { text: "", options: ["", ""], allowMultiple: false },
        { text: "", options: ["", ""], allowMultiple: false },
      ],
      feedBackQuestions: [
        { text: "", options: ["", ""], allowMultiple: false },
        { text: "", options: ["", ""], allowMultiple: false },
        { text: "", options: ["", ""], allowMultiple: false },
      ],
      themeId:null,
      active: false,
      expandedWeek: 0, // index of currently expanded week (0-based)
      weeksData: Array(4).fill().map(() =>
        Array(7).fill().map(() => ({
          prompt: "",
          task: "",
          video_link: "",
          startNotification: "",
          notCompletedNotification: "",
          completedNotification: ""
        }))
      )
    };
  }



  componentDidMount (){
    if ( this.props.history.location?.state?.category_Id ) {
      this.setState({ pillar_Id: this.props.history.location?.state?.category_Id  });
      this.GetChallengeLevelNumber();
    }


  }


  printAction = (bool) => {
    this.setState({printSampleBiometricCSV:bool});
  }


  isUrl = (videoUrl) => {
    const UrlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    UrlRegex.test(videoUrl);
    if (UrlRegex.test(videoUrl)) {
      this.setState({
        isVideoUrl: true,
        iseventUrlMsg: "",
      });
    } else {
      this.setState({
        isVideoUrl: false,
        iseventUrlMsg: "Please enter valid URL",
      });
    }
  };


  handleChange = (index, e) => {
    const newOptions = [...this.state.options];
    newOptions[index] = e.target.value;
    this.setState({ options: newOptions });
  };

  //   handleAddOption = () => {
  //     if (this.state.options.length < 5) {
  //       this.setState((prevState) => ({
  //         options: [...prevState.options, ""],
  //       }));
  //     }
  //   };


  //   handleAddOption = (questionId) => {
  //     this.setState((prevState) => ({
  //       questions: prevState.questions.map((q) =>
  //         q.id === questionId
  //           ? { ...q, options: [...q.options, `Option ${q.options.length + 1}`] }
  //           : q
  //       ),
  //     }));
  //   };


  //   toggleSwitch = () => {
  //     this.setState((prevState) => ({ active: !prevState.active }));
  //   };

  toggleWeek = (weekIndex) => {
    this.setState((prevState) => ({
      expandedWeek: prevState.expandedWeek === weekIndex ? null : weekIndex
    }));
  };


  onSelectCategoryType = (selectedItem) => {
    this.setState({
      selectedCategory: selectedItem.month+(selectedItem.month?" - ":"")+ selectedItem.theme_text,
      themeId: selectedItem.month_number,
    });
  };

  onSelectPoints =(name)=> {
    this.setState({
      selectedChallengePoint: name.value,
      challengePointKey: name.key,
      challengePointValue: name.value,
    });
  }


  // onSelectPoints = (name, /*value, key*/) => {
  //   this.setState({
  //     [name]: name.value,
  //     challengePointKey: name.key,
  //     challengePointValue: name.value,
  //   });
  // };

  onChangeInput = (e) => {
    if(e.target.value.charAt(0) !== ' '){
      this.setState({
        [e.target.name]: e.target.value,
      });
    }

    if (e.target.name === "videoUrl") {
      this.isUrl(e.target.value);
    }

  };


  //   onChangeInputDay = (dayIndex, fieldName, value) => {
  //     if (value.charAt(0) !== ' ') {
  //       this.setState((prevState) => {
  //         const updatedDays = [...prevState.daysData];
  //         updatedDays[dayIndex] = {
  //           ...updatedDays[dayIndex],
  //           [fieldName]: value
  //         };
  //         return { daysData: updatedDays };
  //       });
  //     }
  //   };



  onChangeInputDay = (weekIndex, dayIndex, field, value) => {
    this.setState((prevState) => {
      const weeksData = [...prevState.weeksData];
      weeksData[weekIndex][dayIndex] = {
        ...weeksData[weekIndex][dayIndex],
        [field]: value
      };
      return { weeksData };
    });
  };
  
  
  onChangeURL = (e) => {
    if(e.target.value.charAt(0) !== ' '){
      this.setState({
        url: e.target.value,
      });
    }
  };

  onChangeTime = (e) => {
    const numValidate = /^[0-9\b]+$/;
    if (e.target.value === "" || numValidate.test(e.target.value)) {
      this.setState({ time: e.target.value });
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };


  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
    });
  }

  //   onChangeGoldImage = (baseImage, imageName) => {
  //     this.setState({
  //       goldBadgeImgSrc: baseImage,
  //       goldBadgeImageName: imageName,
  //     });
  //   }
  
  
  //   onChangeSilverImage = (baseImage, imageName) => {
  //     this.setState({
  //       silverBadgeImgSrc: baseImage,
  //       silverBadgeImageName: imageName,
  //     });
  //   }
  
  
  //   onChangeBronzeImage = (baseImage, imageName) => {
  //     this.setState({
  //       BronzeBadgeImgSrc: baseImage,
  //       BronzeImageName: imageName,
  //     });
  //   }


  onSelectClass = (name, value, key) => {
    const selectedValues = [...this.state[name]];
  
    if (selectedValues.includes(value)) {
      const index = selectedValues.findIndex((item) => item === value);
      if (index > -1) selectedValues.splice(index, 1);
    } else {
      if (selectedValues.length < 5) {
        selectedValues.push(value);
      }
    }
  
    this.setState({
      [name]: selectedValues,
      classTypeKey: key,
      coachId: null,
      coachName: '',
    }, () => {
      if (name === "classCategoryTypeValue") {
        this.fetchCoachData(this.state.classCategoryTypeValue);
      }
    });
  };
  

  eventButtonStatusHover = () => {
    this.setState({
      showBack: true,
    });
  };


  eventButtonStatus = () => {
    this.setState({
      showBack: false,
    });
  };


  prepareStep3Payload = () => {
    const { weeksData } = this.state;
  
    const tasks = [];
  
    weeksData.forEach((week, weekIndex) => {
      week.forEach((day, dayIndex) => {
        tasks.push({
          week: weekIndex + 1,
          day: dayIndex + 1,
          prompt: day.prompt || "",
          task: day.task || "",
          video_link: day.video_link || "",
          starting_notification: day.startNotification || "",
          incomplete_notification: day.notCompletedNotification || "",
          completed_notification: day.completedNotification || "",
        });
      });
    });
  
    return {
      "step-3": {
        tasks: tasks
      }
    };
  };


  prepareStepFourPayload = () => {
    const { questions } = this.state;
  
    return {
      "step-4": {
        has_pre_quiz: true, // or dynamic if you add a toggle
        pre_quiz_questions: questions.map((q, index) => ({
          question: q.text,
          order: index + 1,
          allow_multiple_respondents: q.allowMultiple,
          answers: q.options
            .filter((opt) => opt.trim() !== "") // remove empty options
            .map((opt) => ({ answer: opt }))
        }))
      }
    };
  };

  prepareStepFivePayload = () => {
    const { feedBackQuestions } = this.state;
  
    return {
      "step-5": {
        has_post_quiz: true, // or dynamic if you add a toggle
        post_quiz_questions: feedBackQuestions.map((q, index) => ({
          question: q.text,
          order: index + 1,
          allow_multiple_respondents: q.allowMultiple,
          answers: q.options
            .filter((opt) => opt.trim() !== "") // remove empty options
            .map((opt) => ({ answer: opt }))
        }))
      }
    };
  };


  GetChallengeLevelNumber = async()=>{
    const { pillar_Id } = this.state;
    let apiUrl = GetChallengeLevel + "/" + pillar_Id;
    try{
      const res = await fetchApi(apiUrl, "GET");

      if(res?.status === "success"){
        toast.success(res.data[0]);
        this.setState({challenge_level:res.data.current_level});

      }else{
        toast.error(res.data.message);
      }
    }catch(error){
      toast.error(error);
    }
  }


  // getAllWellbeingPillars = async (language) => {
  //   try {
  //     const res = await fetchApi(GetWellbeingPillars + "/" + language, "GET");


  //     if (res.status === "success") {
  //       this.setState({WellbeingPillars:res.data});
  //     } else {
  //       toast.error((res.data.message || "Something went wrong"));

  //     }
  //   } catch (error) {
  //     window.console.error(error);
  //   }
  // }; 
  




  saveChallengeDetails = () => {
    const {
      title,
      description,
      imgSrc,
      videoTitle,
      videoUrl,
      challenge_level,
      challengePointValue,
      pillar_Id
    } = this.state;
    this.setState({
      // buttonStatus: true,
      loading:true
    });
   
  
    const step3Payload = this.prepareStep3Payload();
    const step4Payload = this.prepareStepFourPayload();
    const step5Payload = this.prepareStepFivePayload();

    ChallengeData={
      "step-1": {
        "pillar_id": pillar_Id,
        "title":  title,
        "description": description,
        "image":imgSrc,
      },
      "step-2": {
        "intro_video_title": videoTitle,
        "intro_video_link": videoUrl,
        "intro_video_thumbnail": "base64_encoded_thumbnail",
        "challenge_level": challenge_level,
        "points": challengePointValue,
      },
      ...step3Payload,
      ...step4Payload,
      ...step5Payload,
    }
    
    
      
    // const ChallengeData = {
    //   pillar_id: 3,
    //   image: imgSrc,
    //   description: description,
    //   gold_badge_icon: goldBadgeImgSrc,
    //   silver_badge_icon: silverBadgeImgSrc,
    //   bronze_badge_icon: bronzeBadgeImgSrc,
    // };


    this.PostCreateChallenge(ChallengeData);
  };
  
  
  PostCreateChallenge = async(payload)=>{
    try{
      const res = await fetchApi(AddWellnessChallenge, "POST",payload);

      if(res?.status === "success"){
        toast.success(res.data[0]);
        this.props.history.push({pathname:"/company/challenges/challenge-category"})
        this.setState({
          // buttonStatus: false,
          loading:false
        });
      }else{
        toast.error(res.data.message);
        this.setState({
          // buttonStatus: false,
          loading:false
        });
      }
    }catch(error){
      toast.error(error);
      this.setState({
        // buttonStatus: false,
        loading:false
      });
    }
  }
  

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString === "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
 
    const plainText = newContent.replace(/<[^>]*>/g, "").trim(); 
    const currentLength = plainText.length;
    this.setState({charCount: currentLength});
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop:true });
  };

  close = () =>(
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{maskType: "alpha",}}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  )

  redirect=()=>{
    this.props.history.goBack();
  }
  
  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect }>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      Create Wellbeing Challenge
    </FormHeading>
  );


      
  stepOneForm = () => {
    const {
      // title,
      // url,
      description,
      step,
      charCount,
    } = this.state;

    const { t } = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container  color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category"/>
            </div>
            <div className="form">
             
              <div className="formBody">
               
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Title of the challenge")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter challenge title/name")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={this.state.title}
                    maxLength="30"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <div className="count">{this.state.title?.length}/30 | C</div>
                </InputContainer> 

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/>

                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Challenge image")}{<span>*</span>} <span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                />
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <InputContainer  isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("About the challenge")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor content={description} onChange={this.onChangeDescription} />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (value) => {
    this.setState({ selectedOption: value }, () => { });
  };

 

  onDropDownSelect = (key, item) => {
    this.setState({
      [key]: item
    });
  };

  onDropDownSelectCoach = (name, id, value) => {
    this.setState({
      [name]: id,
      coachName: value
    });
  };

  stepTwoForm = () => {
    const {
      step,
      challengePointValue,
      challengePointKey,
      iseventUrlMsg
    
     
    } = this.state;


    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" >
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category"/>
            </div>
            <div className="form">
              <div className="formBody" >
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video Title")}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter title")}
                    name="videoTitle"
                    onChange={this.onChangeInput}
                    value={this.state.videoTitle}
                    maxLength="30"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                </InputContainer> 


               


                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/>
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video")}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter URL")}
                    name="videoUrl"
                    onChange={this.onChangeInput}
                    value={this.state.videoUrl}
                    maxLength="30"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <span style={{ color: "#DA6C74",fontFamily: "Lato",fontSize: '12px'}}>{iseventUrlMsg}</span>
                </InputContainer>


                {/* <React.Fragment>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video")}{<span>*</span>}</StyledLabel>   
                  <StyledInputV2
                    placeholder={t("Enter event URL")}
                    name="eventLink"
                    onChange={this.onChangeInput}
                    value={eventLink}
                    bgColor={"white"}
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <span style={{ color: "#DA6C74",fontFamily: "Lato",fontSize: '12px'}}>{iseventUrlMsg}</span>
                </React.Fragment> */}


                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/> 
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Challenge Level")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Level number")}
                    name="challenge_level"
                    onChange={this.onChangeInput}
                    value={this.state.challenge_level}
                    maxLength="30"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                    disabled
                  />
                </InputContainer> 
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/>


                <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={("Challenge point value")}
                  isSubText={"(per day)"}
                  dropdownOpen={this.state.so}
                  placeholder={("Select Point")}
                  // title={challengePointKey=="0 Points"?"No Points":challengePointKey ? (challengePointKey) : ("Select point")}
                  title={
                    challengePointKey
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={wellnessChallengePoints}
                  onSelect={this.onSelectPoints}
                  active={challengePointValue}
                  itemValue={true}
                  onSelectParameter={["value", "key"]}
                  // onSelectParameter={["month", "id", "theme_icon"]}
                  dropIcon={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                />
               
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };






  handleFiles = (e) => {
    this.setState({
      file: "",
      fileName: "",
      csvUpload: false,
    });

    let file = e.target.files[0];
    if (!file) return;

    const fileName = file?.name;
    let checkCSV = fileName.split(".");
    if (checkCSV[checkCSV.length - 1].toLowerCase() !== "csv") {
      toast.error("Please select .csv format only");
      document.getElementById("csv-upload-input").value = "";
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: reader.result ? reader.result : "data:",
        fileName: fileName,
        csvUpload: true,
        // data: [
        //   { fname: "", lname: "", mail: "" } // initial structure
        // ],
      }, () => {
        // ✅ Once state is set, immediately call your API
        this.PostCsvToJson();
      });
    };
  };


  PostCsvToJson = async() => {   
    const { file } = this.state;
    const payload = {
      csv_base64: file, 
    };
    
    try{
      const res = await fetchApi(ConvertCsvToJson, "POST",payload);

      if(res?.status === "success"){
        toast.success(res.data.message);
        const weeksData = Array(4).fill().map(() =>
          Array(7).fill().map(() => ({
            prompt: "",
            task: "",
            video_link: "",
            startNotification: "",
            notCompletedNotification: "",
            completedNotification: ""
          }))
        );
    
        // Fill the weeksData with the JSON values
        res.data.data.forEach((item) => {
          const wIndex = item.week - 1;
          const dIndex = item.day - 1;
    
          if (weeksData[wIndex] && weeksData[wIndex][dIndex]) {
            weeksData[wIndex][dIndex] = {
              prompt: item.prompt || "",
              task: item.task || "",
              video_link: item.video_link || "",
              startNotification: item.starting_notification || "",
              notCompletedNotification: item.incomplete_notification || "",
              completedNotification: item.completed_notification || ""
            };
          }
        });
  
        // 🔹 Set state so form auto-fills
        this.setState({ weeksData,expandedWeek: 0});

        // this.setState({
        //   weeksData: res.data.data, // Assuming the API returns weeksData in the expected format
        //   expandedWeek: 0, 
        // });
      }else{
        toast.error(res.data.message);
      }
    }catch(error){
      toast.error(error);
    }
  }


   

  //   removeFile = () => {
  //     this.setState({
  //       file: null,
  //       fileName: "",
  //       csvUpload: false,
  //     });
  //     document.getElementById("csv-upload-input").value = "";
  //   };

  
  removeFile = () => {
    // Reset file input field
    const fileInput = document.getElementById('new-employee-file');
    if (fileInput) {
      fileInput.value = '';
    }
  
    // Reset state
    this.setState({
      csvUpload: false,
      fileName: '',
      file: ''
    });
  };


  getCSVHeaders = () => {

    const csvHeaders = [
      { label: "Week", key: "fname" },
      { label: "Day", key: "lname" },
      { label: "Prompt", key: "user_email" },
      { label: "Task", key: "fname" },
      { label: "Video Link", key: "lname" },
      { label: "Starting Notification", key: "user_email" },
      { label: "Incomplete Notification", key: "lname" },
      { label: "Completed Notification", key: "user_email" },
    ];
  
    return csvHeaders;
  };





  stepThreeForm = () => {

    const {
      step,
      selectedOption,
      fileName,
      csvUpload,
      printSampleBiometricCSV
    } = this.state;


    return(
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category"/>
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">
                  {this.props.t("How would you like to add challenge goal")}
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 0}
                        onChange={() => this.toggleRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"CSV upload"}</div>              
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 1}
                        onChange={() => this.toggleRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Manual upload"}</div>              
                    </div>
                  </RadioButtonWrapper>
                </div>
               
                {selectedOption === 0 ? <>
                  <Border style={{ background: '#EFEFEF', margin: '4px 0px' }} />
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Add CSV document")}{<span>*</span>}</StyledLabel>
                  <UploadPhotoContainer showBorder={false}>
                    <div className="innerDivImageContainer">
                      {csvUpload ? (
                        <RemoveImageV2>
                          <div className="uploadImage">
                            <div className="promotional-doc">
                              <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                              <div>
                                <span
                                  className="promotional-doc-name"
                                  title={fileName}
                                >
                                  {fileName}
                                </span>
                              </div>
                            </div>
                            <div className="main-div" onClick={this.removeFile}>
                              <div className="icon-div">
                                <div className="sub-icon-div">
                                  {CloseIconBranding("#F37A65", "8", "8")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </RemoveImageV2>
                      ) : (
                        <div className="uploadImage">
                          <InputImage
                            className="edit-profile-pic"
                            imageReload={1}
                            style={{ background: "unset", color: "#184A61" }}
                          >
                            <div
                              className="middle-section"
                              onClick={() => this.csvInputRef.current.click()}
                            >
                              <div>{UploadHDMIcon()}</div>
                              <div className="title">{("Upload File")}</div>
                              <div className="sub-title">{("(.csv)")}</div>
                            </div>
                            <input
                              className="input-section"
                              id="csv-upload-input"
                              type="file"
                              accept=".csv"
                              multiple={false}
                              onChange={this.handleFiles}
                              ref={this.csvInputRef}
                              style={{ display: "none" }}
                            />
                          </InputImage>
                        </div>
                      )}
                    </div>
                  </UploadPhotoContainer>
                </>  :null}

                {selectedOption === 0 && !csvUpload ? <ActionButton
                  onClick={()=>this.setState({printSampleBiometricCSV:true})}>
                  Download Sample
                </ActionButton> : null}
   

                {/* <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} /> */}

                { ( csvUpload  && selectedOption === 0)  ||   selectedOption === 1 ? <WeekWrapper styel={{ marginTop: "20px" }}>
                  {this.state.weeksData.map((week, weekIndex) => (
                    <div key={weekIndex}>
                      {/* Week Header */}
                      <WeekContainer onClick={() => this.toggleWeek(weekIndex)} style={{ cursor: "pointer",marginTop:"20px" }}>
                        <div className="weeekText">Week {weekIndex + 1}</div>
                        <div style={{ transform: this.state.expandedWeek === weekIndex ? "rotate(0deg)" : "rotate(180deg)", transition: "transform 0.3s" }}>
                          {WeekDropdownIcon()}
                        </div>
                      </WeekContainer>

                     
                      {weekIndex !== this.state.weeksData.length - 1 ? (
                        <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                      ):
                        null
                      }

                      {/* (this.state.expandedWeek === weekIndex && (
                          <Border style={{ background: '#EFEFEF', margin:  '20px 0 8px 0px', display: "flex" }} />
                        )) */}

                
                      {/* Days - only render if expanded */}
                      {this.state.expandedWeek === weekIndex && week.map((day, dayIndex) => (
                        <React.Fragment key={dayIndex}>

                          { weekIndex === this.state.weeksData.length - 1 
                            ?  <Border style={{ background: '#EFEFEF', margin: '20px 0px 8px 0px', display: "flex" }} /> : null}
                          <div className="dayText">Day {dayIndex + 1}</div>
                
                          {/* Prompt */}
                          <InputContainer>
                            <StyledLabel isFont="14px" color="#184A61" margin="0px">
                              {this.props.t("Prompt")}<span>*</span>
                            </StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter prompt")}
                              value={day.prompt}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'prompt', e.target.value)}
                              maxLength="300"
                              style={{ background: "white" }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                            <div className="count">{day.prompt.length}/300 | C</div>
                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                
                          {/* Task */}
                          <InputContainer>
                            <StyledLabel isFont="14px" color="#184A61" margin="0px">
                              {this.props.t("Task")}<span>*</span>
                            </StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter task")}
                              value={day.task}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'task', e.target.value)}
                              maxLength="300"
                              style={{ background: "white" }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                            <div className="count">{day.task.length}/300 | C</div>
                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                
                          {/* Video Link */}
                          <InputContainer>
                            <StyledLabel isFont="14px" color="#184A61" margin="0px">
                              {this.props.t("Video link")}
                            </StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter URL")}
                              value={day.video_link}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'video_link', e.target.value)}
                              maxLength="30"
                              style={{ background: "white" }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                
                          {/* Notifications */}
                          <InputContainer>
                            <StyledLabel margin={"0px"}>{this.props.t("Notification")}  <span className="subtext">(while starting a day)</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              value={day.startNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'startNotification', e.target.value)}
                              maxLength="30"
                              style={{ background: "white" }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/> 
                          <InputContainer>
                            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Notification")} <span className="subtext">{("(If the task is not completed)")}</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              name="videoUrl"
                              value={day.notCompletedNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex,dayIndex, 'notCompletedNotification', e.target.value)}
                              maxLength="30"
                              style={{background:"white"}}
                              pColor={"#BDBDBD"}
                              color="#184A61"
                              border={"1px solid #BDBDBD"}
                            />
                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/> 
    
                          <InputContainer>
                            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Notification")} <span className="subtext">{("(If the task is completed)")}</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              name="videoUrl"
                              value={day.completedNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex,dayIndex, 'completedNotification', e.target.value)}
                              maxLength="30"
                              style={{background:"white"}}
                              pColor={"#BDBDBD"}
                              color="#184A61"
                              border={"1px solid #BDBDBD"}
                            />
                          </InputContainer>
                          {weekIndex !== this.state.weeksData.length - 1 && (
                            <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  ))}
                </WeekWrapper> : null} 
              </div>
            </div>
          </Container>
        </div>
        {printSampleBiometricCSV && <CSVList Title={`${"Sample file"}`} removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={[]} />}
      </Layout>
    )
  }



  //   stepFourForm = () => {
  //     const {
  //       step,
  //     } = this.state;
  
  //     const optionLabels = ["A", "B", "C", "D", "E"];
  
  //     return(
  //       <Layout>
  //         <div className="main">
  //           {this.renderHeading()}
  //           <Container color="#005C87">
  //             <div className="stepsNameHighlight">
  //               <StepsHeading stepCount={step} type="wellness-challenge-category"/>
  //             </div>
  //             <div className="form">
  //               <div className="formBody">
  //                 <WeekContainer  style={{ cursor: "pointer" }}>
  //                   <div className="weeekText">Question 1</div>
  //                   <div>
  //                     {WeekDropdownIcon()}
  //                   </div>
  //                 </WeekContainer>
  //                 <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
  //                 <InputContainer>
  //                   <StyledLabel isFont="14px" color="#184A61" margin="0px">
  //                     {this.props.t("What would you like to ask?")}<span>*</span>
  //                   </StyledLabel>
  //                   <StyledInputV2
  //                     placeholder={this.props.t("Enter question")}
  //                     value={this.state.question}
  //                     onChange={ this.onChangeInput}
  //                     maxLength="300"
  //                     style={{ background: "white" }}
  //                     pColor="#BDBDBD"
  //                     color="#184A61"
  //                     border="1px solid #BDBDBD"
  //                   />
  //                   <div className="count">{this.state.question}/300 | C</div>
  //                 </InputContainer>
  //                 <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                 
  //                 <div>
  //                   <StyledLabel isFont="14px" color="#184A61" margin="0px">
  //                     {this.props.t("Options")}<span>*</span>
  //                   </StyledLabel>
            
  //                   {this.state.options.map((option, index) => (
  //                     <OptionsContainer
  //                       key={index}
  //                       style={{
  //                         display: "flex",
  //                         flexDirection: "row",
  //                         alignItems: "center",
  //                         gap: "12px",
  //                         width: "100%",
  //                         marginBottom: "8px",
  //                       }}
  //                     >
  //                       <div className="questionsText">
  //                         <div className="questionsNumber">{optionLabels[index]}</div>
  //                       </div>
  //                       <StyledInputV2
  //                         placeholder={this.props.t("Add option")}
  //                         value={option}
  //                         onChange={(e) => this.handleChange(index, e)}
  //                         maxLength="300"
  //                         style={{ background: "white", flex: 1 }}
  //                         pColor="#BDBDBD"
  //                         color="#184A61"
  //                         border="1px solid #BDBDBD"
  //                       />
  //                     </OptionsContainer>
  //                   ))}
            
  //                   {this.state.options.length < 5 && (
  //                     <MoreOptionText onClick={this.handleAddOption}>
  //                       Add More Option (Max 5)
  //                     </MoreOptionText>
  //                   )}
  //                 </div>
  //                 <ToggleContainer>
  //                   <ToggleWrapper active={this.state.active} onClick={this.toggleSwitch}>
  //                     <ToggleCircle active={this.state.active} />
  //                   </ToggleWrapper>
  //                   <div className="respondsText"> Allow respondents to select multiple answers</div>
  //                 </ToggleContainer>
  //                 <Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />
  //               </div>
  //             </div>
  //           </Container>
  //         </div>
  //       </Layout>
  //     )
  //   }


  handleQuestionChange = (qIndex, e) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].text = e.target.value;
    this.setState({ questions: newQuestions });
  };
  
  handleOptionChange = (qIndex, optionIndex, e) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options[optionIndex] = e.target.value;
    this.setState({ questions: newQuestions });
  };
  
  handleAddOption = (qIndex) => {
    const newQuestions = [...this.state.questions];
    if (newQuestions[qIndex].options.length < 5) {
      newQuestions[qIndex].options.push("");
    }
    this.setState({ questions: newQuestions });
  };
  
  toggleSwitch = (qIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].allowMultiple = !newQuestions[qIndex].allowMultiple;
    this.setState({ questions: newQuestions });
  };


  handleFeedBackQuestionChange = (qIndex, e) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].text = e.target.value;
    this.setState({ feedBackQuestions: newQuestions });
  };
  
  handleFeedBackOptionChange = (qIndex, optionIndex, e) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].options[optionIndex] = e.target.value;
    this.setState({ feedBackQuestions: newQuestions });
  };
  
  handleFeedBackAddOption = (qIndex) => {
    const newQuestions = [...this.state.feedBackQuestions];
    if (newQuestions[qIndex].options.length < 5) {
      newQuestions[qIndex].options.push("");
    }
    this.setState({ feedBackQuestions: newQuestions });
  };
  
  toggleFeedBackSwitch = (qIndex) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].allowMultiple = !newQuestions[qIndex].allowMultiple;
    this.setState({ feedBackQuestions: newQuestions });
  };
  


  stepFourForm = () => {
    const { step, activeQuestion, questions } = this.state;
    const optionLabels = ["A", "B", "C", "D", "E"];

  
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
  
            <div className="form">
              {/* Loop through questions */}
              {questions.map((q, qIndex) => (
                <div key={qIndex}>
                  {/* Question Header */}
                  <WeekContainer
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        activeQuestion: activeQuestion === qIndex ? null : qIndex,
                      })
                    }
                  >
                    <div className="weeekText">Question {qIndex + 1}</div>
                    <div
                      style={{
                        transform:
                          activeQuestion === qIndex ? "rotate(0deg)" : "rotate(180deg)",
                        transition: "0.3s",
                      }}
                    >
                      {WeekDropdownIcon()}
                    </div>
                  </WeekContainer>

                  {qIndex !== questions.length - 1 ? (
                    <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                  ):
                    (activeQuestion === qIndex && (
                      <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                    ))}
  
                  {/* Body only visible if this question is active */}
                  {activeQuestion === qIndex && (
                    <div className="formBody">
                      {/* Question Input */}
                      <InputContainer>
                        <StyledLabel isFont="14px" color="#184A61" margin="0px">
                          {this.props.t("What would you like to ask?")}
                        </StyledLabel>
                        <StyledInputV2
                          placeholder={this.props.t("Enter question")}
                          value={q.text}
                          onChange={(e) => this.handleQuestionChange(qIndex, e)}
                          maxLength="150"
                          style={{ background: "white" }}
                          pColor="#BDBDBD"
                          color="#184A61"
                          border="1px solid #BDBDBD"
                        />
                        <div className="count">{q.text.length}/150 | C</div>
                      </InputContainer>
  
                      <Border
                        style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }}
                      />
  
                      {/* Options */}
                      <div>
                        <StyledLabel isFont="14px" color="#184A61" margin="0px">
                          {this.props.t("Options")}<span>*</span>
                        </StyledLabel>
  
                        {q.options.map((option, index) => (
                          <OptionsContainer
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "12px",
                              width: "100%",
                              marginBottom: "12px",
                            }}
                          >
                            <div className="questionsText">
                              <div className="questionsNumber">
                                {optionLabels[index]}
                              </div>
                            </div>
                            <StyledInputV2
                              placeholder={this.props.t("Add option")}
                              value={option}
                              onChange={(e) => this.handleOptionChange(qIndex, index, e)}
                              maxLength="300"
                              style={{ background: "white", flex: 1 }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                          </OptionsContainer>
                        ))}
  
                        {q.options.length < 5 && (
                          <MoreOptionText onClick={() => this.handleAddOption(qIndex)}>
                            Add More Option (Max 5)
                          </MoreOptionText>
                        )}
                      </div>
  
                      {/* Toggle */}
                      <ToggleContainer>
                        <ToggleWrapper
                          active={q.allowMultiple}
                          onClick={() => this.toggleSwitch(qIndex)}
                        >
                          <ToggleCircle active={q.allowMultiple} />
                        </ToggleWrapper>
                        <div className="respondsText">
                          Allow respondents to select multiple answers
                        </div>
                      </ToggleContainer>
                      <Border
                        style={{ background: "#EFEFEF", margin: "8px 0 8px 0px" }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Container>
        </div>
      </Layout>
    );
  };
  


  stepFiveForm = () => {
    const {
      step,
      feedBackQuestions,
      feedbackActiveQuestion,
      levelOpen,
      challenge_level
    } = this.state;
    const optionLabels = ["A", "B", "C", "D", "E"];
    return(
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category"/>
            </div>
            <div className="form">


              <WeekContainer
                style={{ cursor: "pointer", marginBottom: "10px" }}
                onClick={() => this.setState({ levelOpen: !levelOpen })}
              >
                <div className="weeekText">Level {challenge_level}</div>
                <div
                  style={{
                    transform: levelOpen ? "rotate(0deg)" : "rotate(180deg)",
                    transition: "0.3s",
                  }}
                >
                  {WeekDropdownIcon()}
                </div>
              </WeekContainer>
            
              {/* Loop through questions */}
              { levelOpen && (  feedBackQuestions.map((q, qIndex) => (
                <div key={qIndex}>
                  {/* Question Header */}
                  <WeekContainer
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        feedbackActiveQuestion: feedbackActiveQuestion === qIndex ? null : qIndex,
                      })
                    }
                  >
                    <div className="weeekText">Question {qIndex + 1}</div>
                    <div
                      style={{
                        transform:
                        feedbackActiveQuestion === qIndex ? "rotate(0deg)" : "rotate(180deg)",
                        transition: "0.3s",
                      }}
                    >
                      {WeekDropdownIcon()}
                    </div>
                  </WeekContainer>


                  {qIndex !== feedBackQuestions.length - 1 ? (
                    <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                  ):
                    (feedbackActiveQuestion === qIndex && (
                      <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                    ))}
  
                  {/* Body only visible if this question is active */}
                  {feedbackActiveQuestion === qIndex && (
                    <div className="formBody">
                      {/* Question Input */}
                      <InputContainer>
                        <StyledLabel isFont="14px" color="#184A61" margin="0px">
                          {this.props.t("What would you like to ask?")}
                        </StyledLabel>
                        <StyledInputV2
                          placeholder={this.props.t("Enter question")}
                          value={q.text}
                          onChange={(e) => this.handleFeedBackQuestionChange(qIndex, e)}
                          maxLength="150"
                          style={{ background: "white" }}
                          pColor="#BDBDBD"
                          color="#184A61"
                          border="1px solid #BDBDBD"
                        />
                        <div className="count">{q.text.length}/150 | C</div>
                      </InputContainer>
  
                      <Border
                        style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }}
                      />
  
                      {/* Options */}
                      <div>
                        <StyledLabel isFont="14px" color="#184A61" margin="0px">
                          {this.props.t("Options")}<span>*</span>
                        </StyledLabel>
  
                        {q.options.map((option, index) => (
                          <OptionsContainer
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "12px",
                              width: "100%",
                              marginBottom: "8px",
                            }}
                          >
                            <div className="questionsText">
                              <div className="questionsNumber">
                                {optionLabels[index]}
                              </div>
                            </div>
                            <StyledInputV2
                              placeholder={this.props.t("Add option")}
                              value={option}
                              onChange={(e) => this.handleFeedBackOptionChange(qIndex, index, e)}
                              maxLength="300"
                              style={{ background: "white", flex: 1 }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                          </OptionsContainer>
                        ))}
 
                        {q.options.length < 5 && (
                          <MoreOptionText onClick={() => this.handleFeedBackAddOption(qIndex)}>
                            Add More Option (Max 5)
                          </MoreOptionText>
                        )}
                      </div>
  
                      {/* Toggle */}
                      <ToggleContainer>
                        <ToggleWrapper
                          active={q.allowMultiple}
                          onClick={() => this.toggleFeedBackSwitch(qIndex)}
                        >
                          <ToggleCircle active={q.allowMultiple} />
                        </ToggleWrapper>
                        <div className="respondsText">
                          Allow respondents to select multiple answers
                        </div>
                      </ToggleContainer>
                      <Border
                        style={{ background: "#EFEFEF", margin: "8px 0 8px 0px" }}
                      />
                    </div>
                  )}
                </div>
              )))  }
            </div>
          </Container>
        </div>
      </Layout>
    )
  }


  isNextDisabled = () => {
    const { weeksData } = this.state;
    return weeksData.some((week) =>
      week.some((day) => day.prompt.trim() === "" || day.task.trim() === "")
    );
  };

  isStepFourNextDisabled = () => {
    const { questions } = this.state;
  
    return questions.some((q) => {
      const filledOptions = q.options.filter((opt) => opt.trim() !== "");
      return filledOptions.length < 2 || q.text.trim() === "";
    });
  };


  // isStepFiveNextDisabled = () => {
  //   const { feedBackQuestions } = this.state;
  //   return feedBackQuestions.some((q) => {
  //     const filledOptions = q.options.filter((opt) => opt.trim() !== "");
  //     return filledOptions.length < 2 || q.text.trim() === "";
  //   });
  // };

  render() {
    const {
      description,
      imgSrc,
      charCount,
      step,
      title,
      // videoTitle,
      // videoUrl,
      challenge_level,
      challengePointValue,
      loading,
     
    } = this.state;

    if (loading) {
      return <Waiting />;
    }

    // const isDisabled = !goldBadgeImgSrc || !silverBadgeImgSrc|| !bronzeBadgeImgSrc;
   
    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : step === 2 ? this.stepTwoForm() : step === 3 ? this.stepThreeForm() : step === 4 ? this.stepFourForm() : this.stepFiveForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title || !imgSrc|| !description || (charCount > 3000)} onClick={!title  || !imgSrc|| !description || (charCount > 3000) ? null: () => this.updateStep(2)}>
               Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) :  step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
              
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                 Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" 
                // disabled={isDisabled}
                disabled={ !challenge_level || !challengePointValue}
                onClick={
                  !challenge_level || !challengePointValue
                    ? null
                    : () => this.updateStep(3)
                }
                // onClick={!buttonstatus ? isEditCategory? () => this.editOndemandEvent() :  () => this.saveOndemandEvent() : null}
              >Next 
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ):
          step === 3 ?
            (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(2)}
                    margin="auto auto auto 0px">
                   Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"  disabled={this.isNextDisabled()}   onClick={ this.isNextDisabled() ? null :() => this.updateStep(4)}>
                  Next
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            )  : step === 4 ? (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(3)}
                    margin="auto auto auto 0px">
                   Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"  disabled={this.isStepFourNextDisabled()} onClick={ this.isStepFourNextDisabled() ? null :() => this.updateStep(5)}>
                  Next
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            ) : step === 5 && (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(4)}
                    margin="auto auto auto 0px">
                 Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" /*disabled={this.isStepFiveNextDisabled()}  onClick={ this.isStepFiveNextDisabled() ? null : () => this.saveChallengeDetails()}  */    onClick={() => this.saveChallengeDetails()} >
                  Create Challenge
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            )
        }
      </React.Fragment>
    );
  }
}

CreateChallengeForm.propTypes = {
  createOndemand: PropTypes.func.isRequired,
  fetchOndemandCategory: PropTypes.func,
  ondemandCategory: PropTypes.array,
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  fetchOndemandEventDetailsById: PropTypes.func.isRequired,
  ondemandEventDetail: PropTypes.object,
  isEditCategory: PropTypes.object,
  EditOndemandEventVideo: PropTypes.func,
};





export default (withTranslation()(CreateChallengeForm));